import { Button, Col, DatePicker, Form, Input, message, Row, Select } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import dayjs from 'dayjs';
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../app/hooks';
import { setCommonModal } from '../../../common/slices/modalSlice';
import { useSetRemainderMutation } from '../../../modules/Client/Client/api/endpoints/clientEndpoints';

interface IPostReminder {
  client_id: string;
  invoice_id: number;
  reminder_type: string;
  send_body: string;
  send_date: string;
  partial_payment_amount: number;
  client_name: string;
  send_by: number;
  send_by_name: string;
  partial_due_date: string;
}

const SetRemainderPost = ({ data }: { data: any }) => {
  const user = useAppSelector((state) => state.user);
  const dispatch = useAppDispatch();
  const [form] = Form.useForm();
  const [postReminder, { isLoading, isSuccess }] = useSetRemainderMutation();
  console.log(data, 'data');
  useEffect(() => {
    if (isSuccess) {
      message.success('Remainder Sent Successfully');
      dispatch(setCommonModal());
      form.resetFields();
      form.setFieldsValue({
        client_name: data?.client_name,
        invoice_no: data?.invoice_no,
        partial_payment_amount: dueAmount,
      });
    }
  }, [isSuccess, form, dispatch]);
  const netTotal = Number(data?.net_total || 0);
  const paidAmount = Number(data?.invclientpayment_amount || 0);
  const dueAmount = netTotal - paidAmount;
  useEffect(() => {
    form.setFieldsValue({
      client_name: data?.client_name,
      invoice_no: data?.invoice_no,
      partial_payment_amount: dueAmount,
    });
  }, [data, form]);

  const onFinish = async (values: any) => {
    const body: IPostReminder = {
      client_id: data?.comb_client,
      invoice_id: data?.invoice_id,
      reminder_type: values?.reminder_type,
      send_body: values.send_body,
      send_date: values?.send_date,
      partial_due_date: dayjs(values?.partial_due_date).format('YYYY-MM-DD'),
      partial_payment_amount: Number(values?.partial_payment_amount),
      client_name: values?.client_name,
      send_by: user?.user_id as number,
      send_by_name: user?.user_full_name as string,
    };

    await postReminder(body);
  };

  return (
    <>
      <Form
        initialValues={{ send_date: dayjs(), reminder_type: 'mail' }}
        name='reminder_form'
        onFinish={onFinish}
        autoComplete='off'
        layout='vertical'
        form={form}
      >
        <Row gutter={[10, 10]}>
          <Col span={8}>
            <Form.Item name={'client_name'} label='Client Name'>
              <Input variant='filled' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'invoice_no'} label='Invoice No'>
              <Input variant='filled' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'send_date'} label='Current Date'>
              <DatePicker
                allowClear={false}
                style={{ width: '100%' }}
                variant='filled'
                disabledDate={(current) => current && !current.isSame(dayjs(), 'day')}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name='reminder_type' label='Reminder Type'>
              <Select
                options={[
                  { label: 'Sms', value: 'sms' },
                  { label: 'Mail', value: 'mail' },
                  { label: 'Phonecall', value: 'phonecall' },
                  { label: 'Whatsapp', value: 'whatsapp' },
                  { label: 'Visit', value: 'visit' },
                  { label: 'Other', value: 'other' },
                ]}
              />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'partial_payment_amount'} label='Amount'>
              <Input readOnly variant='filled' placeholder='e.g: 2500' />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item name={'partial_due_date'} label='Due Date'>
              <DatePicker
                style={{ width: '100%' }}
                variant='filled'
                disabledDate={(current) => current && current > dayjs().startOf('day')}
              />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Form.Item name={'send_body'} label='Message'>
              <TextArea
                variant='filled'
                placeholder='e.g: Hi, Please find the payment reminder for invoice'
              />
            </Form.Item>
          </Col>
        </Row>

        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            disabled={
              Number(data?.net_total || 0) <= Number(data?.invclientpayment_amount || 0) ||
              !!data?.invoice_is_refund
            }
          >
            Submit
          </Button>
        </Form.Item>
      </Form>
    </>
  );
};

export default SetRemainderPost;
